export const UNIFIED_EVENTS_ENABLED = 'unified.events.enabled'; // For Preroll / Midroll
export const UNIFIED_EVENTS_DISPLAY_ENABLED =
  'unified.events.enabled.displayads';
export const UNIFIED_EVENTS_INSTREAM_ENABLED =
  'unified.events.enabled.instreamads';
export const UNIFIED_EVENTS_BATCH_INTERVAL_SECS =
  'unified.events.batch.interval.seconds';
export const UNIFIED_EVENTS_MAX_BATCH_COUNT = 'unified.events.max.batch.count';
export const UNIFIED_EVENTS_CONTENT_ENABLED = 'unified.events.content.enabled';
